import type { PackageRegistryEntry } from '@shared/core';
import type { TelehealthEnvironmentConfig } from '@shared/telehealth/client';
import { JitsiBrowserTelehealthAdapter } from '@shared/telehealth/jitsi';
import { TelehealthPackageBootstrap } from '@shared/telehealth/client';

const browserAdapter = new JitsiBrowserTelehealthAdapter();

export const TELEHEALTH_REGISTRY: PackageRegistryEntry<TelehealthEnvironmentConfig> = {
  definition: new TelehealthPackageBootstrap('browser'),
  config: {
    development: { options: {}, adapters: [browserAdapter] },
    preview: { options: {}, adapters: [browserAdapter] },
    production: { options: {}, adapters: [browserAdapter] },
  },
};
